export default __webpack_public_path__ + "app/images/937bf75adcc4049c1488c9b587f2eb66.png";